import { Locale, type LocalizedString } from "../Locale.js";

export const signInPathMap = {
	[Locale.cs]: "prihlaseni" as const,
} satisfies LocalizedString;
